import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); // Reset scroll to top
    }, [pathname]);

    return null; // No rendering needed
};

export default ScrollToTop;